module.exports = __webpack_public_path__ + "static/media/welcom-frame-img-3.f8baf43b.jpg";